import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch } from 'react-redux';
import Stack from '@mui/material/Stack';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { trainerMOUTableHeader } from './utils/trainerMOUTableHeader';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import AddnUpdateMOU from './components/AddnUpdateMOU';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { getTrainerMOUTable } from '../../../../redux/features/crdMigrationSlice';
import ViewScrnShot from './components/ViewScrnShot';

export default function TrainerMOU() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const loading = useSelector((state) => state.crdMigration.trainerMOUTable.loading);
  const trainerMOUTable = useSelector((state) => state.crdMigration.trainerMOUTable.data);
  const meta = useSelector((state) => state.crdMigration.trainerMOUTable.meta);
  //--------------------------------------------------------------------------

  // react state

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortDirection: tableState?.sort?.direction,
    }),
    [tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getTrainerMOUTable(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  // ------- Dialogue

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Add',
        title: 'Add MOU Details',
        maxWidth: 'md',
        render: ({ row }) => (
          <AddnUpdateMOU
            successDispatch={dispatchParams}
            successDispatchFn={getTrainerMOUTable}
            setModalState={setModalState}
          />
        ),
      },
      {
        actionKey: 'Update',
        title: 'Update MOU Details',
        maxWidth: 'md',
        render: ({ row }) => (
          <AddnUpdateMOU
            row={row}
            successDispatch={dispatchParams}
            successDispatchFn={getTrainerMOUTable}
            setModalState={setModalState}
          />
        ),
      },
      {
        actionKey: 'View ScrnShot',
        title: 'View Attachment',
        maxWidth: 'md',
        render: ({ row }) => <ViewScrnShot row={row} />,
      },
    ],
    [dispatchParams],
  );
  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey]);

  return (
    <GlobalWrapper title={'Trainer MOU Details'}>
      <GlobalDialog
        title={activeConfig?.title}
        open={Boolean(modalState?.actionKey)}
        setOpen={(val) => {
          if (!val) setModalState({ actionKey: '', row: null });
        }}
        closeButton={true}
        content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
        maxWidth={activeConfig?.maxWidth || 'md'}
        fullWidth={true}
      />
      <Stack gap={2}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            alignSelf: 'flex-end',
          }}
          onClick={() =>
            setModalState({
              actionKey: 'Add',
            })
          }
        >
          Add
        </Button>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={trainerMOUTableHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          onButtonActionClick={handleButtonActionClick}
          rows={trainerMOUTable}
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
